import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { LessonSongCssService } from '../lesson-song-css.service'
import * as $ from 'jquery';

@Component({
  selector: 'app-resizeable-column',
  templateUrl: './resizeable-column.component.html',
  styleUrls: ['./resizeable-column.component.scss']
})
export class ResizeableColumnComponent implements OnInit {
  @Input() columnName: string
  @Input() columnText: string
  width: number
  resizeable: boolean

  private start: any
  private pressed: boolean
  private startX: any
  private startWidth: any

  constructor(private lessonSongCssService: LessonSongCssService,
              public renderer: Renderer2) { }

  private onMouseDown(event) {
    this.start = event.target
    this.pressed = true
    this.startX = event.x
    this.startWidth = $(this.start).parent().width()
    this.initResizableColumns()
  }

  private initResizableColumns() {
    this.renderer.listen('body', 'mousemove', (event) => {
      if (this.pressed) {
        const width = this.startWidth + (event.x - this.startX)
        this.width = this.lessonSongCssService.setColumnWidth(this.columnName, width).width
        $(this.start).parent().css({'min-width': this.width, 'max-width': this.width})
        const index = $(this.start).parent().index() + 1
        $('.glowTableBody tr td:nth-child(' + index + ')').css({'min-width': width, 'max-width': width})
      }
    })
    this.renderer.listen('body', 'mouseup', (event) => {
      if (this.pressed) {
        this.pressed = false
        this.lessonSongCssService.resetUserSet()
      }
    })
  }

  ngOnInit(): void {
    this.lessonSongCssService.widthChanged.subscribe(() =>  this.width = this.lessonSongCssService.columnWidth(this.columnName))
    this.width = this.lessonSongCssService.columnWidth(this.columnName)
    this.resizeable = this.lessonSongCssService.resizeable(this.columnName)
  }
}
